import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";

import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";

import DashboardOverview from "@/pages/dashboard/DashboardOverview";
import ChildrenList from "@/pages/dashboard/ChildrenList";
import ChildDetail from "@/pages/dashboard/ChildDetail";

import PlaySelectChild from "@/pages/play/PlaySelectChild";
import PlayHub from "@/pages/play/PlayHub";
import GalaxyDefender from "@/pages/play/games/GalaxyDefender";
import ColorForest from "@/pages/play/games/ColorForest";
import BuildersWorkshop from "@/pages/play/games/BuildersWorkshop";
import StarPath from "@/pages/play/games/StarPath";
import PortCrane from "@/pages/play/games/PortCrane";
import SilenceTemple from "@/pages/play/games/SilenceTemple";
import PatternLabyrinth from "@/pages/play/games/PatternLabyrinth";
import NPCVillage from "@/pages/play/games/NPCVillage";
import MagicThermometer from "@/pages/play/games/MagicThermometer";
import EchoCave from "@/pages/play/games/EchoCave";
import AnimalChoir from "@/pages/play/games/AnimalChoir";
import SecretLibrary from "@/pages/play/games/SecretLibrary";
import GuardianPortal from "@/pages/play/games/GuardianPortal";
import ShipLog from "@/pages/play/games/ShipLog";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardOverview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/children"
              element={
                <ProtectedRoute>
                  <ChildrenList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/children/:id"
              element={
                <ProtectedRoute>
                  <ChildDetail />
                </ProtectedRoute>
              }
            />

            <Route
              path="/play"
              element={
                <ProtectedRoute>
                  <PlaySelectChild />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/hub"
              element={
                <ProtectedRoute>
                  <PlayHub />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/galaxy-defender"
              element={
                <ProtectedRoute>
                  <GalaxyDefender />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/color-forest"
              element={
                <ProtectedRoute>
                  <ColorForest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/builders-workshop"
              element={
                <ProtectedRoute>
                  <BuildersWorkshop />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/star-path"
              element={
                <ProtectedRoute>
                  <StarPath />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/port-crane"
              element={
                <ProtectedRoute>
                  <PortCrane />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/silence-temple"
              element={
                <ProtectedRoute>
                  <SilenceTemple />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/pattern-labyrinth"
              element={
                <ProtectedRoute>
                  <PatternLabyrinth />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/npc-village"
              element={
                <ProtectedRoute>
                  <NPCVillage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/magic-thermometer"
              element={
                <ProtectedRoute>
                  <MagicThermometer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/echo-cave"
              element={
                <ProtectedRoute>
                  <EchoCave />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/animal-choir"
              element={
                <ProtectedRoute>
                  <AnimalChoir />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/secret-library"
              element={
                <ProtectedRoute>
                  <SecretLibrary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/guardian-portal"
              element={
                <ProtectedRoute>
                  <GuardianPortal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/play/game/ship-log"
              element={
                <ProtectedRoute>
                  <ShipLog />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
